import { render, staticRenderFns } from "./Defects.vue?vue&type=template&id=ac9332ea&scoped=true&"
import script from "./Defects.vue?vue&type=script&lang=js&"
export * from "./Defects.vue?vue&type=script&lang=js&"
import style0 from "./Defects.vue?vue&type=style&index=0&id=ac9332ea&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ac9332ea",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VDataTable,VSelect,VTextField})
